import { createSlotRecipe } from './runtime';

const editableConfig = {"name":"editable","slots":["root","area","label","preview","input","editTrigger","submitTrigger","cancelTrigger","control"]}

export const editable = /* @__PURE__ */ createSlotRecipe(editableConfig)